import { ApiError } from '@shared/api/problem';

/**
 * Перевод машинного кода ошибки в ключ i18n.
 *
 * Логика UI завязана только на `code` из problem+json (MVP_TECH_RFC §21):
 * `detail` приходит на английском и предназначен разработчику, показывать его
 * пользователю нельзя.
 */
const CODE_TO_KEY: Record<string, string> = {
  // Запрос кода
  OTP_RESEND_TOO_SOON: 'auth.errors.resendTooSoon',
  OTP_EMAIL_LIMIT_REACHED: 'auth.errors.emailLimit',
  OTP_IP_LIMIT_REACHED: 'auth.errors.ipLimit',
  OTP_IP_DAILY_LIMIT_REACHED: 'auth.errors.ipLimit',
  LEGAL_DOCUMENT_UNKNOWN: 'auth.errors.legalUnknown',

  // Проверка кода
  OTP_INVALID: 'auth.errors.codeInvalid',
  OTP_EXPIRED: 'auth.errors.codeExpired',
  OTP_ALREADY_USED: 'auth.errors.codeUsed',
  OTP_ATTEMPTS_EXCEEDED: 'auth.errors.attemptsExceeded',
  LEGAL_ACCEPTANCE_REQUIRED: 'auth.errors.legalRequired',
  ACCOUNT_BLOCKED: 'auth.errors.accountBlocked',

  // Транспорт и защита
  NETWORK_ERROR: 'auth.errors.network',
  VALIDATION_ERROR: 'auth.errors.validation',
  CSRF_TOKEN_MISSING: 'auth.errors.session',
  CSRF_TOKEN_INVALID: 'auth.errors.session',
  CSRF_ORIGIN_MISMATCH: 'auth.errors.session',
};

/** Ошибки, после которых текущий код мёртв и нужно запросить новый. */
const TERMINAL_CODE_ERRORS = new Set(['OTP_EXPIRED', 'OTP_ALREADY_USED', 'OTP_ATTEMPTS_EXCEEDED']);

export function authErrorKey(error: unknown): string {
  if (error instanceof ApiError) {
    return CODE_TO_KEY[error.code] ?? 'auth.errors.unexpected';
  }
  return 'auth.errors.unexpected';
}

/** Код больше не проверить: форма ввода блокируется, предлагается новый код. */
export function isTerminalCodeError(error: unknown): boolean {
  return error instanceof ApiError && TERMINAL_CODE_ERRORS.has(error.code);
}

/**
 * Сколько секунд ждать до повторной попытки.
 *
 * Значение берётся из заголовка `Retry-After`, который backend присылает вместе
 * с 429. В теле problem+json оно не дублируется, поэтому при отсутствии
 * заголовка возвращается `null`, и сообщение показывается без таймера.
 */
export function retryAfterSeconds(error: unknown): number | null {
  return error instanceof ApiError ? error.retryAfterSeconds : null;
}
